import { auth } from '@/models/auth'

export default {
  auth(config: any) {
    const authData = auth.getAuth()
    const token = authData.token
    config.headers.Authorization = `Bearer ${token}`

    return config
  },
}
